<template>
  <div class="footerNavigation">
    <nav class="footerNavigation__block row">
      <div
        v-for="nav, i in navigation"
        :key="nav.link + i"
        class="col flex flex-auto"
      >
        <div
          class="subMenu"
          :class="{ 'active': nav.active }"
        >
          <button
            :aria-label="nav.descr"
            class="btn-clear subMenu__title text-second-800 font-bold"
            @click="nav.active = !nav.active"
          >
            {{ nav.title }}
          </button>
          <div
            v-if="nav.subMenu"
            class="subMenu__block text-second-800/80"
          >
            <ul>
              <li
                v-for="subMenu, subMenuIndex in nav.subMenu"
                :key="subMenu.link + subMenuIndex"
              >
                <NuxtLink
                  :aria-label="subMenu.descr"
                  :to="subMenu.link"
                  @click="scrollTop"
                >
                  {{ subMenu.title }}
                </NuxtLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script setup>
const { confNavigation } = useConfig()

const navigation = ref(confNavigation.footer)

const scrollTop = () => {
  window.scrollTo(0,0)
}
</script>

<style lang="scss">
.footerNavigation {
  padding: 0;
  border: 0;
  &__block {
    .subMenu {
      &__title {
        position: relative;
        display: block;
        width: 100%;
        padding: 1rem 2rem 1rem 0;
        font-size: 1rem;
        line-height: 1.45;
        text-align: inherit;
      }
      &__block {
        ul {
          margin: 0;
          font-size: 11px;
          line-height: 1.42;
          li {
            margin-bottom: 10px;
            a {
              display: flex;
              padding: 5px 0;
              color: inherit;
              font-weight: 500;
              &:hover {
                color: color("primary-color", "base");
              }
            }
          }
        }
        @media only screen and (max-width: 600px) {
          display: grid;
          overflow: hidden;
          transition: grid-template-rows .2s;

          grid-template-rows: 0fr;
          ul {
            align-self: end;
            min-height: 0;
            transition: visibility .5s;
            visibility: hidden;
          }
        }
      }
    }
    @media only screen and (max-width: 600px) {
      & > .col {
        width: 100%;
        .subMenu {
          width: 100%;
          &__title {
            border-bottom: 1px solid #eaedf0;
            &:after,
            &:before {
              content: "";
              position: absolute;
              top: 50%;
              right: 5px;
              display: block;
              width: 12px;
              height: 2px;
              background: color("primary-color", "base");
                      transition: -webkit-transform .3s ease-in-out 0s;
                      transition:         transform .3s ease-in-out 0s;
                      transition:         transform .3s ease-in-out 0s, -webkit-transform .3s ease-in-out 0s;

              -webkit-transition: -webkit-transform .3s ease-in-out 0s;
            }
            &:after {
              transform: rotate(90deg);
            }
          }
          &.active {
            .subMenu {
              &__title {
                &:after {
                  transform: rotate(0);
                }
              }
              &__block {
                grid-template-rows: 1fr;
                ul {
                  visibility: visible;
                }
              }
            }
          }
        }
        &:first-child {
          .subMenu {
            &__title {
              border-top: 1px solid #eaedf0;
            }
          }
        }
      }
    }
  }
}
</style>
